module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/thunder-13dd506d430f07559759c15108e9998d.svg";